<template>
  <div>
    <b-row class="mb-4" v-if="!isPreview">
      <b-col cols="12">
        <b-form-group label="Notes *">
          <b-form-textarea
            v-model="formComment.comment"
            rows="5"
            placeholder="Type your comment here..."
          />
        </b-form-group>
      </b-col>
      <b-col md="6" class="text-right">
        <button
          :disabled="!formComment.comment"
          type="button"
          class="btn btn-outline-primary w-100"
          @click="formComment.comment = ''"
          >Cancel & Close</button
        >
      </b-col>
      <b-col md="6" class="text-right">
        <button
          :disabled="!formComment.comment"
          type="button"
          class="btn btn-primary w-100"
          @click="saveComment()"
          >Submit Comment</button
        >
      </b-col>
    </b-row>

    <div class="overflow-auto d-flex w-100" style="max-height: 400px">
      <template v-if="comments?.length > 0">
        <MaintenanceLogs
          :logs="comments"
          namekey="created_by"
          datekey="create_at"
          descriptionkey="comment"
        />
      </template>
      <span class="text-muted text-center" v-else>Tidak ada komentar.</span>
    </div>
  </div>
</template>
<script>
import { pmsActions } from '@/src/Utils/helper'
import moment from 'moment'
import MaintenanceLogs from './MaintenanceLogs.vue'

export default {
  name: 'MaintenanceCommentFormNew',
  components: {
    MaintenanceLogs,
  },
  props: {
    isPreview: Boolean,
    selectedData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      comments: [],
      formComment: {
        comment: '',
        user_id: JSON.parse(localStorage.getItem('profile')).id,
      },
    }
  },
  methods: {
    ...pmsActions,
    moment(date) {
      return moment(date)
    },
    async fetchComments() {
      try {
        const payload = {
          maintenance_id: this.selectedData.id,
        }
        const res = await this.getCommentPms(payload)
        if (res.status == 'success') {
          this.comments = res.data?.data?.map((item) => ({
            ...item,
            created_by: item?.user?.username,
          }))
        }
      } catch (error) {
        console.log(error)
      }
    },
    async saveComment() {
      let payload = {
        maintenanceId: this.selectedData?.id,
        data: this.formComment,
      }
      const res = await this.createCommentPms(payload)

      if (res.status === 'success') {
        this.formComment.comment = ''
        this.$emit('refetch')
        this.$swal.fire(
          'Success!',
          'Your comment has been added successfully.',
          'success'
        )
        this.fetchComments()
      } else {
        this.$swal(`Oops!`, res.data.message, 'error')
      }
    },
  },
  mounted() {
    this.fetchComments()
  },
}
</script>
